import { useState } from 'react'
import PropTypes from 'prop-types'
import { group } from 'd3-array'
import styled from '@emotion/styled'
import { Box, Flex, Text } from 'rebass'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { useModal } from 'react-modal-hook'
import ModalContainer from '../atoms/ModalContainer'
import TimelineToolTip from '../molecules/TimelineToolTip'
import PersonFetcher from '../organisms/PersonFetcher'
import { makeDate } from '../../utils/helpers'

const TimelineFlex = styled(Flex)`
  width: 100%;
  ${Mq.sm} {
    margin-top: 2rem;
  }
`

const ColGroup = styled(Flex)`
  //border: 1px solid yellow;
  justify-content: center;
  align-items: flex-end;
  //flex: 1;
  width: 100%;
`

const Column = styled(Flex)`
  flex-direction: column;
  //border: 1px solid green;
  justify-content: flex-end;
  align-items: center;
  //flex: 1;
  width: 100%;
`
const Circle = styled(Box)`
  position: relative;
  background-color: ${(props) => props.theme.colors.red};
  //border-radius: 50%;
  width: 4px;
  height: 2px;
  margin: 1px 0;
  cursor: pointer;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.aqua};
  }
  ${Mq.xs} {
    width: 6px;
  }
  ${Mq.sm} {
    width: 60%;
  }
`

const Tick = styled.div`
  border-top: 1px solid white;
  border-right: 1px solid white;
  border-left: ${(props) => (props.first ? '1px solid white' : null)};
  margin-top: 1px;
  width: 100%;
  height: 7px;
`
const TimeLineDate = styled(Text)`
  color: ${(props) => props.color};
  font-size: 0.75rem;
`

const IntroTimeLine = ({ data, years, ui }) => {
  const [showToolTip, setShowToolTip] = useState(0)
  const [shift, setShift] = useState(false)
  const [personId, setPersonId] = useState(null)

  const groupedByYear = group(data, (d) => d.year) // a map
  //const sorted = [...groupedByYear.entries()].sort((a, b) => a[0] - b[0])
  const numYearsToShow = years[1] - years[0] + 2 //to make inclusive and bring up to 2020
  const handleMouseEnter = (d, currYear) => {
    if (currYear >= 2000) setShift(true)

    return d ? setShowToolTip(d.id) : null
  }

  const handleMouseLeave = () => {
    setShowToolTip(null)
    setShift(false)
  }

  const [showPersonModal, hidePersonModal] = useModal(
    () => (
      <ModalContainer
        hideModal={hidePersonModal}
        setPersonId={setPersonId}
        personId={personId}
      >
        <PersonFetcher personId={personId} />
      </ModalContainer>
    ),
    [personId]
  )

  return (
    <TimelineFlex>
      {/* ternary is to prevent this from erroring when filters on map find no cases */}
      {[...Array(numYearsToShow > 0 ? numYearsToShow : 0)].map((_, i) => {
        const startYear = years[0]
        const currYear = +startYear + i

        //console.log('length', groupedByYear.get(currYear.toString()))
        // const length = groupedByYear.get(currYear.toString())
        //   ? groupedByYear.get(currYear.toString()).length
        //   : null
        // const numColumns = (length) => {
        //   if (!length) return 0
        //   const base = Math.ceil(length / 40)
        //   return base
        // }
        const base = 200
        const needSecondCol =
          groupedByYear.get(currYear.toString())?.length > base

        return (
          <Column key={i}>
            <ColGroup key={currYear}>
              <Column key={currYear + 'a'}>
                {groupedByYear.get(currYear.toString()) &&
                  groupedByYear.get(currYear.toString()).map((d, i) => {
                    return (
                      i < base && (
                        <Circle
                          key={d.id}
                          onMouseEnter={() => handleMouseEnter(d, currYear)}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => {
                            setPersonId(d.id)
                            showPersonModal()
                          }}
                        >
                          <TimelineToolTip
                            show={showToolTip === d.id}
                            shift={shift}
                            d={d}
                            key={d.date + d.id}
                          />
                        </Circle>
                      )
                    )
                  })}
              </Column>
              {needSecondCol && (
                <Column key={currYear + 'b'}>
                  {groupedByYear.get(currYear.toString()) &&
                    groupedByYear.get(currYear.toString()).map((d, i) => {
                      return (
                        i >= base && (
                          <Circle
                            key={d.id}
                            onMouseEnter={() => handleMouseEnter(d, currYear)}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => {
                              setPersonId(d.id)
                              showPersonModal()
                            }}
                          >
                            <TimelineToolTip
                              show={showToolTip === d.id}
                              shift={shift}
                              d={d}
                              key={d.date}
                            />
                          </Circle>
                        )
                      )
                    })}
                </Column>
              )}
            </ColGroup>

            <Tick first={i === 0} key={currYear + 'tick'} />
            <TimeLineDate
              color={currYear % 10 === 0 ? 'white' : 'transparent'}
              mt={1}
              key={currYear + 'tock'}
            >
              {currYear % 10 === 0
                ? makeDate(currYear.toString() + '0000', ui)
                : '0000'}
            </TimeLineDate>
          </Column>
        )
      })}
    </TimelineFlex>
  )
}

export default IntroTimeLine

IntroTimeLine.propTypes = {
  data: PropTypes.array,
  years: PropTypes.array,
  ui: PropTypes.string
}
